import { useCallback, useEffect, useState } from 'react';
import { isActiveWelcomeBonus, useFirstDepositBonus } from '../../queries/bonus';
import { PAYMENT_TRANSACTION_TYPE } from '../../types/enums';

type UseWithdrawalBonusGuardOptions = {
  isWithdrawal: boolean;
  resetToDeposit: () => void;
};

export const useWithdrawalBonusGuard = ({ isWithdrawal, resetToDeposit }: UseWithdrawalBonusGuardOptions) => {
  const [isForfeitDialogOpen, setIsForfeitDialogOpen] = useState(false);
  const [withdrawalBonusCleared, setWithdrawalBonusCleared] = useState(false);

  const { data: firstDepositBonus, isLoading: isFirstDepositBonusLoading } = useFirstDepositBonus();

  const shouldShowForfeitDialog = isWithdrawal && isActiveWelcomeBonus(firstDepositBonus) && !withdrawalBonusCleared;
  const shouldBlockWithdrawal =
    isWithdrawal && !withdrawalBonusCleared && (isFirstDepositBonusLoading || shouldShowForfeitDialog);

  useEffect(() => {
    if (shouldShowForfeitDialog) {
      setIsForfeitDialogOpen(true);
    }
  }, [shouldShowForfeitDialog]);

  const closeForfeitDialog = useCallback(() => {
    setIsForfeitDialogOpen(false);
  }, []);

  const handleForfeitCancel = useCallback(() => {
    closeForfeitDialog();
    resetToDeposit();
  }, [closeForfeitDialog, resetToDeposit]);

  return {
    firstDepositBonus,
    isFirstDepositBonusLoading,
    isForfeitDialogOpen,
    withdrawalBonusCleared,
    shouldShowForfeitDialog,
    shouldBlockWithdrawal,
    setIsForfeitDialogOpen,
    setWithdrawalBonusCleared,
    closeForfeitDialog,
    handleForfeitCancel,
  };
};
